import { Reveal } from "@/components/Reveal";
import { SectionLabel } from "@/components/home/SectionLabel";
import { STEPS, IMAGES } from "@/data/content";

export function HowItWorks() {
    return (
        <section className="bg-stone2/50 border-y border-linec">
            <div className="max-w-[1240px] mx-auto px-6 lg:px-10 py-20 grid lg:grid-cols-[0.9fr_1.1fr] gap-12 lg:gap-16 items-center">
                <Reveal>
                    <div className="img-frame rounded-sm relative">
                        <img
                            src={IMAGES.reception}
                            alt="Modern dental office reception"
                            className="w-full h-[300px] lg:h-[480px] object-cover rounded-sm"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-sage/40 to-transparent rounded-sm" />
                    </div>
                </Reveal>
                <div>
                    <Reveal>
                        <SectionLabel className="text-terracotta">How it works</SectionLabel>
                        <h2 className="font-heading text-4xl sm:text-5xl tracking-tight text-ink mt-4 max-w-xl">
                            From first call to fully live, without disrupting your team.
                        </h2>
                    </Reveal>
                    <div className="mt-10 space-y-px">
                        {STEPS.map((step, i) => (
                            <Reveal key={step.n} delay={i * 0.08}>
                                <div className="group flex gap-5 bg-cream border border-linec rounded-sm p-6 transition-colors duration-300 hover:border-terracotta/60">
                                    <div className="font-heading text-4xl text-terracotta/90 shrink-0 w-14">
                                        {step.n}
                                    </div>
                                    <div>
                                        <h3 className="font-heading text-xl text-ink">{step.title}</h3>
                                        <p className="text-sm text-inksoft leading-relaxed mt-1.5">
                                            {step.blurb}
                                        </p>
                                    </div>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
